import { Operation } from 'components/organisms/tasks/filters/operations';
import { SelectFilterOperationType } from 'components/organisms/tasks/filters/select';
import { unreachable } from 'utils/unreachable';
import { fromApiValue, toType } from './select';
const toApiFormat = (filter)=>{
    switch(filter.type){
        case SelectFilterOperationType.IsEmpty:
            return {
                operation: Operation.IsEmpty,
                sourceType: filter.field.sourceType
            };
        case SelectFilterOperationType.IsNotEmpty:
            return {
                operation: Operation.IsNotEmpty,
                sourceType: filter.field.sourceType
            };
        case SelectFilterOperationType.Is:
            var _filter_value;
            return {
                operation: Operation.Value,
                value: ((_filter_value = filter.value) !== null && _filter_value !== void 0 ? _filter_value : []).join(','),
                sourceType: filter.field.sourceType
            };
        case SelectFilterOperationType.IsNot:
            var _filter_value1;
            return {
                operation: Operation.IsNot,
                value: ((_filter_value1 = filter.value) !== null && _filter_value1 !== void 0 ? _filter_value1 : []).join(','),
                sourceType: filter.field.sourceType
            };
        case SelectFilterOperationType.IsNoneOf:
            var _filter_value2;
            return {
                operation: Operation.NoneOf,
                value: ((_filter_value2 = filter.value) !== null && _filter_value2 !== void 0 ? _filter_value2 : []).join(','),
                sourceType: filter.field.sourceType
            };
        case SelectFilterOperationType.IsOneOf:
            var _filter_value3;
            return {
                operation: Operation.OneOf,
                value: ((_filter_value3 = filter.value) !== null && _filter_value3 !== void 0 ? _filter_value3 : []).join(','),
                sourceType: filter.field.sourceType
            };
        default:
            return unreachable(filter);
    }
};
const parse = ({ value, operation }, field)=>{
    const type = toType(operation);
    switch(type){
        case SelectFilterOperationType.IsEmpty:
        case SelectFilterOperationType.IsNotEmpty:
            return {
                field,
                type
            };
        case SelectFilterOperationType.Is:
        case SelectFilterOperationType.IsNot:
            return {
                field,
                type,
                value: fromApiValue(value !== null && value !== void 0 ? value : '')
            };
        case SelectFilterOperationType.IsOneOf:
        case SelectFilterOperationType.IsNoneOf:
            return {
                field,
                type,
                value: fromApiValue(value !== null && value !== void 0 ? value : '')
            };
        case SelectFilterOperationType.IsAtLeast:
        case SelectFilterOperationType.IsAtMost:
        default:
            return unreachable(`${type} cannot be parsed for ${field.type} field`);
    }
};
export const MultiUserFilter = {
    parse,
    toApiFormat
};
